export const constantRouterMap = [
	{
		path: "/app",
		component: () => import(/* webpackChunkName: "layout" */ "@/layouts/BasicLayout"),
		children: [
			{
				path: '',
				redirect: "/app/home/"
			},
			{
				path: '/',
				redirect: "/app/home/"
			},
			{
				path: "home/:type",
				name: "home",
				component: () => import(/* webpackChunkName: "home" */ "@/views/Scene/Home")
			},
			{
				path: "home/",
				name: "home-default",
				component: () => import(/* webpackChunkName: "home" */ "@/views/Scene/Home")
			},
			{
				path: "room/:room_id",
				name: "room",
				component: () => import(/* webpackChunkName: "room" */ "@/views/Scene/Room")
			},
			{
				path: "profile",
				name: "profile",
				component: () => import(/* webpackChunkName: "profile" */ "@/views/Scene/Profile")
			},
			{
				path: "download",
				name: "download",
				component: () => import(/* webpackChunkName: "common" */ "@/views/Scene/Download")
			},
			{
				path: "cart",
				name: "cart",
				component: () => import(/* webpackChunkName: "shop" */ "@/views/Scene/Cart")
			},
			{
				path: "goods_detail",
				name: "goods_detail",
				component: () => import(/* webpackChunkName: "Goods" */ "@/views/Scene/GoodsDetail")
			},
			{
				path: "order_list",
				name: "order_list",
				component: () => import(/* webpackChunkName: "order" */ "@/views/Scene/OrderList")
			},
			{
				path: '/order_detail',
				name: 'order_detail',
				component: () => import(/* webpackChunkName: "order" */ "@/views/Scene/OrderDetail")
			},
			{
				path: '/repay',
				name: 'repay',
				component: () => import(/* webpackChunkName: "order" */ "@/views/Scene/Repay")
			},
			{
				path: '/logistics',
				name: 'logistics',
				component: () => import(/* webpackChunkName: "order" */ "@/views/Scene/Logistics")
			},
			{
				path: '/nimChat',
				name: 'chat',
				component: () => import(/* webpackChunkName: "order" */ "@/views/Scene/NimChat")
			},
			{
				path: '/store',
				name: 'store',
				component: () => import(/* webpackChunkName: "order" */ "@/views/Scene/StoreDetail")
			},
			{
				path: '/anchor',
				name: 'anchor',
				component: () => import(/* webpackChunkName: "order" */ "@/views/Scene/Anchor")
			},
		]
	},
	{
		path: '/404',
		name: '404',
		component: () => import(/* webpackChunkName: "exception" */ '@/views/Exception/404')
	},
	{
		path: '*',
		redirect: "/app/home/"
	},




	//@todo 活动路由，计划219需求上线前抽离到活动项目
	// 219版本需求  - /invite_reward页面分享出来的落活动页
	{
		path: "/activity",
		component: () => import(/* webpackChunkName: "activity" */ "@/layouts/ActivityLayout"),
		component: { render: h => h('router-view') },
		redirect: '/app/home',
		children: [
			{
				path:'/activity/share_earn',
				name: 'shareEarn',
				component: ()=>import(/* webpackChunkName: "activity" */ "@/views/Activity/ShareEarn")
			},
            {
                path: '/activity/verified-email',
                name: 'Verified',
                component: () => import(/* webpackChunkName: "verifiedEmail" */ "@/views/VerifiedEmail/index")
            },
		]
	},

]
